/** Entry bracket draft source — orthogonal to positionBracketMode. */
export const BRACKET_DRAFT_TEMPLATE = 'template';
export const BRACKET_DRAFT_MANUAL = 'manual';

/**
 * @typedef {null | typeof BRACKET_DRAFT_TEMPLATE | typeof BRACKET_DRAFT_MANUAL} BracketDraftMode
 */

/** No entry bracket draft (idle or entry-only New Order). */
export function isEntryBracketDraftActive(mode) {
  return mode === BRACKET_DRAFT_TEMPLATE || mode === BRACKET_DRAFT_MANUAL;
}

export function isTemplateBracketDraft(mode) {
  return mode === BRACKET_DRAFT_TEMPLATE;
}

export function isManualBracketDraft(mode) {
  return mode === BRACKET_DRAFT_MANUAL;
}

/** Trade.js / reset should apply saved template SL+TP. */
export function shouldSeedEntryBracketFromTemplate(mode) {
  return mode === BRACKET_DRAFT_TEMPLATE;
}

/** Preserve user-built legs; do not overwrite with template. */
export function shouldPreserveManualLegs(mode) {
  return mode === BRACKET_DRAFT_MANUAL;
}
